import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";

export default class Chart extends React.Component {

    colors = [
        "0099ff",
        "63cfce",
        "ffb380",
        "9c9a63",
        "9ccf31",
        "009a9c",
        "ffcf00",
        "9c9a9c",
        "9ccfce",
        "0065ce",
        "9c9aff",
        "ce6500",
        "cecf63",
        "639a9c",
        "cecfce",
        "9c9ace",
        "633063",
        "639ace",
        "ffcf63",
        "636563",
        "cecf9c",
        "9c3000",
        "319aff",
        "006563",
        "ce9a31",
        "63659c",
        "9c9a31",
        "9ccfff",
        "31659c"
    ];

    getBars(items) {
        return items.map((item,index) => {
            return (
                <Bar key={item.id} dataKey={item.name} unit="%" maxBarSize={80} minPointSize={0} label={item.name} fill={"#" + this.colors[index]} >
                    <LabelList dataKey={item.name} position="center" angle={0} />
                </Bar>
            )
        });
    }

    render() {
        return (
            <ResponsiveContainer width="100%" height={300}>
                <BarChart
                    data={this.props.data}
                    customAxisMax="100"
                    margin={{ top: 0, right: 0, left: -30, bottom: 0 }} >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis domain={[0, 100]} padding={{ bottom: 0 }} />
                    <Tooltip />
                    <Legend />
                    {this.getBars(this.props.bars)}
                </BarChart>
            </ResponsiveContainer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/Chart.js